import React from 'react';
import { requestHelpers } from '../../../helpers';
import Anchor from "../../dashboardNew/objects/Anchor";
import { getField, validate, isValid } from './../../../helpers/common/form';

export default class ForgotPassword extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sent    : false,
            error   : false,
            fields  : [
                {
                    tagName         : "input",
                    name            : "email_address",
                    type            : "email",
                    label           : "Email",
                    placeholder     : "JohnSmith@example.com",
                    required        : true,
                    classOveride    : "col-12 form-group alt"
                }
            ]
        };

        this.formRef = React.createRef();
    }

    onBlurValueValidate = ( evt, type, name ) => this.setState({ fields : [ ...validate( evt, type, name, this.state.fields ) ] } );

    buildFields = () => this.state.fields.map( field => getField( field, this.onBlurValueValidate ) )

    submit(){

        let fields;
        var condition = isValid( this.state.fields );
        var condition2;

        if( condition ){
            let fields;
            this.state.fields.forEach( field => {
                fields = [ ...validate( { target : { value : this.formRef.current.querySelector( `#${ field.name }` ).value } }, field.type, field.name, this.state.fields ) ];
            });
            condition2 = isValid( fields );
            if( condition2 ){ return this.setState({ fields }) };
        };

        const send = () => {

            const body = {};
            this.state.fields.forEach( item => { body[ item.name ] = item.value });
            body.isUK = window.localStorage.getItem('site_of_origin') === 'gb';

            requestHelpers
                .unauthenticatedPostRequest( '/authentication/password/reset', body )
                .then(() => this.setState({ sent : true }))
                .catch( error => this.setState({ error : true }));


        };

        !condition && !condition2 ? send() : this.setState({ fields }, send );

    }

    contactSuccessMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">Your forgotten password request is now being processed.</h3>
                <p className="body-copy">You will receive an email shortly which will allow you to change your password. If you cannot see this email, please check your spam folder.</p>
                <Anchor path='/' anchorClass='theme-button' internal>
                    Go Home
                </Anchor>
            </div>
        );
    }

    contactErrorMessage(){
        return (
            <div className="col-12 contact-success">
                <h3 className="heading-two">There was an error sending your forgotten password request.</h3>
                <p className="body-copy">Oops, it looks like you've encountered an issue during the submission. Please try again.</p>
                <Anchor path='/' anchorClass='theme-button' internal>
                    Go Home
                </Anchor>
            </div>
        );
    }

    content(){
        if( !this.state.sent && !this.state.error ){
            return (
                <form key='form' className="contact-form" ref={ this.formRef }>
                    { this.buildFields() }
                    <div className="col-12 form-group button">
                        <button className="theme-button" type="button" value="button" onClick={() => this.submit()}>Send</button>
                    </div>
                </form>
            );
        };
        if( this.state.error ){ return this.contactErrorMessage() };
        return this.contactSuccessMessage();
    }

    render() {
        return (
            <div className="portal-page-wrapper contact-page theme-page-whole-blue">
                <div className="image" style={{ backgroundImage: 'url(/images/contact.jpg)' }}></div>
                <div className="container inner-content">
                    <div className="row">
                        <div key='heading' className="col-12 heading">
                            <h1 className="heading-main">Forgotten Password</h1>
                            <p className="body-copy">please fill in the form below and we will process your request and send you an email on how to reset your password.</p>
                        </div>
                        { this.content() }
                    </div>
                </div>
            </div>
        );
    };
};




// WEBPACK FOOTER //
// src/client/components/common/authentication/ForgotPassword.js